import {tAsString} from '../../../../../common/helpers/react/text/tAsString';
import {useOnce} from '../../../../../common/helpers/react/hooks/useOnce';
import {useSubtitle} from '../../../../../common/helpers/react/hooks/useSubtitle';
import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import {HistoryTable} from './HistoryTable';

export default function HistoryPresenter() {
    useSubtitle(tAsString('VIEW_HISTORY'));

    const history = useControllers().history;
    useOnce(() => history.refreshHistory()).andWeAreDone();

    return (
        <>
            <h1>{tAsString('VIEW_HISTORY')}</h1>
            <HistoryTable/>
        </>
    );
}
